import React from 'react';
import { Link } from 'react-router-dom';
import red_arrow from '../../assets/sprites/red_arrow.svg';

interface GoToLinkProps {
  to: string;
  state?: any;
}

const GoToLink = ({ to, state }: GoToLinkProps) => {
  return (
    <Link
      to={to}
      state={state}
      className="flex justify-end text-red-600 no-underline gap-0.5 z-[2] text-xs font-montserrat font-semibold leading-7"
    >
      <span>Перейти</span>
      <img src={red_arrow} alt="Перейти" />
    </Link>
  );
};

export default GoToLink;
